import Vue from 'vue'
import Router from 'vue-router'
import less from 'less'
Vue.use(less)

const index = r => require.ensure([], () => r(require('@/components/index.vue')), 'chunkname1')
const skillone = r => require.ensure([], () => r(require('@/components/skillone.vue')), 'chunkname2')
const skilltwo = r => require.ensure([], () => r(require('@/components/skilltwo.vue')), 'chunkname3')
const skillthree = r => require.ensure([], () => r(require('@/components/skillthree.vue')), 'chunkname3')
const auditing = r => require.ensure([], () => r(require('@/components/auditing.vue')), 'chunkname4')
const test = r => require.ensure([], () => r(require('@/components/test.vue')), 'chunkname5')
const testList = r => require.ensure([], () => r(require('@/components/test_list.vue')), 'chunkname6')

const managehome = r => require.ensure([], () => r(require('@/components/managehome.vue')), 'chunkname7')
const manageSkill = r => require.ensure([], () => r(require('@/components/manageSkill.vue')), 'chunkname7')
const manageSkillOne = r => require.ensure([], () => r(require('@/components/manageSkillOne.vue')), 'chunkname8')
const manageSkillTwo = r => require.ensure([], () => r(require('@/components/manageSkillTwo.vue')), 'chunkname8')

const Manskillone = r => require.ensure([], () => r(require('@/components/Manskillone.vue')), 'chunkname2')
const Manskilltwo = r => require.ensure([], () => r(require('@/components/Manskilltwo.vue')), 'chunkname3')
const Manauditing = r => require.ensure([], () => r(require('@/components/Manauditing.vue')), 'chunkname4')
const Mantest = r => require.ensure([], () => r(require('@/components/Mantest.vue')), 'chunkname5')
const MantestList = r => require.ensure([], () => r(require('@/components/Mantest_list.vue')), 'chunkname6')



import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/skillone',
            name: 'skillone',
            component: skillone,
        },
        {
            path: '/skilltwo',
            name: 'skilltwo',
            component: skilltwo
        },
        {
            path: '/skillthree',
            name: 'skillthree',
            component: skillthree
        },
        {
            path: '/auditing',
            name: 'auditing',
            component: auditing
        },
        {
            path: '/test',
            name: 'test',
            component: test
        },
        {
            path: '/testList',
            name: 'testList',
            component: testList
        },
        {
            path: '/managehome',
            name: 'managehome',
            component: managehome
        },
        {
            path: '/manageSkill',
            name: 'manageSkill',
            component: manageSkill
        },
        {
            path: '/manageSkillOne',
            name: 'manageSkillOne',
            component: manageSkillOne
        },
        {
            path: '/manageSkillTwo',
            name: 'manageSkillTwo',
            component: manageSkillTwo
        },
        {
            path: '/Manskillone',
            name: 'Manskillone',
            component: Manskillone,
        },
        {
            path: '/Manskilltwo',
            name: 'Manskilltwo',
            component: Manskilltwo
        },
        {
            path: '/Manauditing',
            name: 'Manauditing',
            component: Manauditing
        },
        {
            path: '/Mantest',
            name: 'Mantest',
            component: Mantest
        },
        {
            path: '/MantestList',
            name: 'MantestList',
            component: MantestList
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js